"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var ToggleSwitch = function ToggleSwitch(_ref) {
  var _cx;

  var disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      className = _ref.className,
      onChange = _ref.onChange,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["disabled", "readOnly", "className", "onChange"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])(classes.ToggleSwitch, (_cx = {}, (0, _defineProperty2["default"])(_cx, classes.Disabled, disabled), (0, _defineProperty2["default"])(_cx, classes.Error, rest['data-has-errors']), (0, _defineProperty2["default"])(_cx, classes.Warning, rest['data-has-warnings']), _cx), className)
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    type: "checkbox",
    disabled: disabled,
    readOnly: readOnly,
    onChange: !disabled && !readOnly ? onChange : undefined
  }, rest)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "toggle-switch-slider round"
  }));
};

exports["default"] = ToggleSwitch;
//# sourceMappingURL=index.js.map